'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orientation = void 0;
var $ = require("jquery");
var Orientation = /** @class */ (function () {
    function Orientation() {
        var _this = this;
        window.addEventListener("orientationchange", function () {
            _this.setResult();
        });
    }
    // 結果表示
    Orientation.prototype.setResult = function () {
        var angle = this.getAngle();
        if (angle.value === undefined) {
            console.log('端末の向きを取得することが出来ませんでした');
            return false;
        }
        if (angle.isPortrait) {
            // 縦向き
            console.log('縦向き');
            $('.bulletLandscape').attr('data-landscape', '0');
        }
        else {
            // 横向き
            console.log('横向き');
            $('.bulletLandscape').attr('data-landscape', '1');
        }
    };
    // 角度を取得
    Orientation.prototype.getAngle = function () {
        var angle = screen && screen.orientation && screen.orientation.angle;
        if (angle === undefined) {
            angle = window.orientation; // iOS用
        }
        var isPortrait = (angle === 0);
        return ({
            value: angle,
            isPortrait: isPortrait,
            isLandscape: !isPortrait, // 横向き
        });
    };
    return Orientation;
}());
exports.Orientation = Orientation;
exports.default = Orientation;
